/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './bookingReviewWidget.scss';

const propTypes = {
    booking: PropTypes.object.isRequired,
};

class BookingReviewWidget extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { client_feedback } = this.props.booking.booking;
        if (client_feedback) {
            const stars = [];
            const rating = client_feedback.score;
            for (let i = 0; i <= 4; i++) {
                const classNames = [
                    'icon icon-star-full',
                    i < rating ? 'active' : '',
                ];
                const star = <i key={i} className={classNames.join(' ')} />;
                stars.push(star);
            }
            return (
                <div className="bookings-review-widget">
                    <div className="bookings-review-widget__stars">{stars}</div>
                </div>
            );
        }
        return (
            <div className="bookings-review-widget">
                <div className="bookings-review-widget__stars">
                    <i className="icon icon-star-full" />
                    <i className="icon icon-star-full" />
                    <i className="icon icon-star-full" />
                    <i className="icon icon-star-full" />
                    <i className="icon icon-star-full" />
                </div>
            </div>
        );
    }
}

BookingReviewWidget.propTypes = propTypes;

export default BookingReviewWidget;
